import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { AdminApi } from "../../../api/adminApi";
const initialState = {
  status: false,
  message: "",
  data: {},
  currentRequestId: undefined,
  loading: "idle",
  action: "",
  error: null,
};

export const sendNotification = createAsyncThunk(
  "admin/sendNotification",
  async (notification, { rejectWithValue, getState, requestId }) => {
    try {
      const { currentRequestId, loading } = await getState().admin;
      if (loading !== "pending" || requestId !== currentRequestId) return;
      const data = await AdminApi.sendNotification({ values: notification });
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
export const getNotification = createAsyncThunk(
  "admin/getNotification",
  async (id, { rejectWithValue, getState, requestId }) => {
    try {
      const { currentRequestId, loading } = await getState().admin;
      if (loading !== "pending" || requestId !== currentRequestId) return;
      const data = await AdminApi.getNotification(id);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const adminSlice = createSlice({
  name: "admin",
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(sendNotification.pending, (state, action) => {
        if (state.loading === "idle") {
          state.loading = "pending";
          state.currentRequestId = action.meta.requestId;
          state.error = null;
        }
      })
      .addCase(sendNotification.fulfilled, (state, action) => {
        const { requestId } = action.meta;
        if (
          state.loading === "pending" &&
          state.currentRequestId === requestId
        ) {
          state.loading = "idle";
          state.data = { ...state.data, notifications: action.payload };
          state.status = action.payload?.status;
          state.currentRequestId = undefined;
          state.action = "send_notification";
        }
      })
      .addCase(sendNotification.rejected, (state, action) => {
        const { requestId } = action.meta;
        if (
          state.loading === "pending" &&
          state.currentRequestId === requestId
        ) {
          state.loading = "idle";
          state.error = action.payload?.message || action.error?.message || "Network error. Please try again.";
          state.status = false;
          state.currentRequestId = undefined;
        }
      })
      .addCase(getNotification.pending, (state, action) => {
        if (state.loading === "idle") {
          state.loading = "pending";
          state.currentRequestId = action.meta.requestId;
          state.error = null;
        }
      })
      .addCase(getNotification.fulfilled, (state, action) => {
        const { requestId } = action.meta;
        if (
          state.loading === "pending" &&
          state.currentRequestId === requestId
        ) {
          state.loading = "idle";
          state.data = { ...state.data, single_notification: action.payload };
          state.status = action.payload?.status;
          state.currentRequestId = undefined;
          state.action = "get_notification";
        }
      })
      .addCase(getNotification.rejected, (state, action) => {
        const { requestId } = action.meta;
        if (
          state.loading === "pending" &&
          state.currentRequestId === requestId
        ) {
          state.loading = "idle";
          state.error = action.payload?.message || action.error?.message || "Network error. Please try again.";
          state.status = false;
          state.currentRequestId = undefined;
        }
      });
  },
});

export default adminSlice.reducer;
